import { jwtDecode } from 'jwt-decode';

/**
 * Safely gets the access token from localStorage.
 */
export const getAccessToken = () => {
  return localStorage.getItem('access_token');
};

const normalizeNamePart = (value) => {
  if (typeof value !== 'string') return null;
  const normalized = value.trim();
  return normalized || null;
};

/**
 * Decodes frontend display identity from an access token.
 * JWT claims are used for display only; authorization remains server-side.
 */
export const decodeUserIdentity = (token) => {
  if (!token) return null;

  try {
    const decoded = jwtDecode(token);
    const firstName = normalizeNamePart(decoded.first_name);
    const lastName = normalizeNamePart(decoded.last_name);

    return {
      userId: decoded.user_id || null,
      firstName,
      lastName,
      displayName: [firstName, lastName].filter(Boolean).join(' ') || null,
    };
  } catch (error) {
    console.error('Failed to decode token:', error);
    return null;
  }
};

/**
 * Gets display identity from the currently stored access token.
 */
export const getUserIdentityFromToken = () => decodeUserIdentity(getAccessToken());

/**
 * Decodes the JWT token and extracts the user_id.
 */
export const getUserIdFromToken = () => {
  return getUserIdentityFromToken()?.userId || null;
};
